// import axios from 'axios'
import API from 'vuex-requests/src/store/backends/API'

export default class AppointmentGuruBackend extends API {
  constructor (name = 'appointmentguru', store, options = {}) {
    super(name, store)
    this.store = store
    this.baseUrl = process.env.APPOINTMENTGURU_API_ROOT
    this.headers = {
      'Content-Type': 'application/json'
    }
  }
  endpoints () { // endpoints are simple GET only requests
    return {
      'auth-identify': {
        url: 'api/auth/identify/',
        method: 'POST',
        params: { phone_number: { type: 'number', required: true } }
      },
      'auth-validate-otp': {
        url: 'api/auth/otp/',
        method: 'POST',
        params: {
          phone_number: { type: 'number', required: true },
          otp: { type: 'number', required: true }
        }
      },
      'auth-forgot-password': {
        url: 'api/auth/forgot-password/',
        method: 'POST',
        requiresAuth: false,
        params: {
          phone_number: { type: 'number', required: true }
        }
      },
      'auth-set-password': {
        url: 'api/auth/set-password/',
        method: 'POST',
        requiresAuth: true,
        params: {
          phone_number: { type: 'number', required: true },
          otp: { type: 'number', required: true }
        }
      },
      'auth-login-phone': {
        url: 'api/auth/phone/token/',
        method: 'POST',
        params: {
          phone_number: { type: 'number', required: true },
          password: { type: 'string', required: true }
        }
      },
      'auth-register': {
        url: 'api/auth/register/',
        method: 'POST',
        params: {
          full_name: { type: 'string', required: true },
          email: { type: 'email', required: true },
          phone_number: { type: 'number', required: true },
          password1: { type: 'string', required: true },
          password2: { type: 'string', required: true }
        }
      },
      'location.touch': {
        url: 'api/v2/practitioner/services/touch/',
        method: 'POST',
        params: {
          name: { type: 'string', required: false }
        }
      },
      'me': {
        url: 'api/users/me/',
        method: 'PATCH',
        params: {}
      }
    }
  }
  resources () { // resource endpoints support standard RESTful CRUD interface
    return {
      login: 'api/auth/login',
      'users': 'api/users/',
      'home': 'api/home/',
      'auth.become': 'api/auth/become/',
      'client.practitioners': 'api/client/practitioners/',
      'client.appointments': 'api/client/appointments/',
      'client.v2.appointments': 'api/v2/client/appointments/',
      'client.v2.compare': 'api/v3/practitioner/relationships/compare/',
      'appointment': 'api/appointments/', // v1: use for create
      'appointment.practitioner.v3': 'api/v3/practitioner/appointments/',
      'appointment.recurring': 'api/appointments/recurring/',
      'appointment.recurring.clashes': 'api/appointments/recurring/precreate/',
      'appointment.clashes': 'api/appointments/clashes/',
      'appointment.bulk': 'api/appointments/bulk/',
      'appointment.codes': 'api/appointments/codes/',
      'appointment.products': 'api/appointments/lineitems/',
      'appointment.codes.many': 'api/appointments/codes/many/',
      'appointment.codes.suggestions': 'api/appointments/codes/suggestions/',
      'appointment.tags': 'api/appointments/tags/',
      appointments: 'api/v2/client/appointments/', // v2: use for get
      process: 'api/appointments/processes/',
      'practitioner.integrations': 'api/v2/practitioner/integrations/',
      'practitioner.integrations.zoom': 'api/v2/practitioner/integrations/zoom/',
      'practitioner.integrations.netcash': 'api/v2/practitioner/integrations/netcash/configure/',
      'practitioner.lookups': 'api/v3/practitioner/practitioners/me/lookups/',
      'practitioner.professions': 'api/practitioners/professions/',
      'practitioner.messages': 'api/practitioners/settings/messages/',
      'practitioner.messages.defaults': 'api/practitioners/settings/messages/defaults/',
      'practitioner.appointments.clashes': 'api/appointments/clashes/',
      'practitioner.me': 'api/v2/practitioner/me/',
      'practitioner.me.profile': 'api/v2/practitioner/me/profile/',
      'practitioner.appointments': 'api/appointments/',
      'practitioner.clients': 'api/v2/practitioner/clients/',
      // 'practitioner.clients': 'api/v3/clients/',
      'practitioner.clients.new': 'api/v2/practitioner/clients/new/',
      'practitioner.services': 'api/v2/practitioner/services/',
      'practitioner.services.address': 'api/v2/practitioner/services/addresses/',
      'practitioner.services.hours': 'api/v2/practitioner/services/hours/',
      'practitioner.services.products': 'api/v2/practitioner/services/products/',
      'practitioner.comms.default': 'api/practitioners/settings/messages/defaults/',
      'practitioner.communications': 'api/practitioners/settings/messages/',
      'practitioner.communications.send': 'api/practitioners/settings/messages/:slug/send/',
      'v3.statement': 'api/v3/practitioner/statement/',
      'v3.1.statement': 'api/v3-1/practitioner/statement/',
      'practitioner.v2.clients.treatment': 'api/v3/practitioner/treatment/',
      'practitioner.v3.clients': 'api/v3/clients/',
      'practitioner.v3.payments': 'api/v3/practitioner/payment/',
      'practitioner.v3.clients.active': 'api/v3/clients/active/',
      'practitioner.v3.dashboard': 'api/v3/clients/active/',
      'practitioner.v3.relationships': 'api/v3/practitioner/relationships/'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/backends/appointmentguru.js